<template>
<div>

  <v-toolbar v-show="lijstofdetail" style=" position: fixed;" dense>
    </v-toolbar-items>
    <v-btn style="margin: 0px;margin-left: 0px;" class="green white--text"  v-on:click.native="nieuweMachineClicked" ><v-icon dark>add</v-icon>Machine</v-btn>
    <v-btn style="margin: 0px;margin-left: 10px;" class="green white--text"  v-on:click.native="nieuweSoortClicked" ><v-icon dark>add</v-icon>Soort</v-btn>
    <v-spacer></v-spacer>
    <v-btn style="margin: 0px;margin-right: 10px;" class="black white--text" v-on:click.native="selectClick" ><v-icon dark>{{selicon}}</v-icon>selectie</v-btn>
    <v-btn style="margin: 0px;margin-right: 10px;" class="purple white--text" :disabled="selmode==0" v-on:click.native="steekkaartenClicked" ><v-icon dark>print</v-icon>Steekkaarten</v-btn>
    <v-btn style="margin: 0px;margin-right: 10px;" class="orange white--text" disabled v-on:click.native="steekkaartenClicked" ><v-icon dark>home</v-icon>Locatie</v-btn>
    <v-btn style="margin: 0px;" class="blue white--text" v-on:click.native="afdrukkenClicked" ><v-icon dark>print</v-icon></v-btn>

  </v-toolbar>

  <div class="topclass" v-show="lijstofdetail">
    <table>
    <thead style=" position: fixed;margin-top:46px;">
      <tr style="height: 60px;margin: 0px;padding:0px;">
        <th class="idcol">ID</th>
        <th class="omschrcol">OMSCHRIJVING</th>
        <th class="loccol">HUIDIGE LOCATIE</th>
        <th class="urofkmcol" >UREN/<br>KM/<br>ONDERH.</th>
        <th class="periodiekecol">PERIODIEKE CONTROLE GELDIG TOT</th>
        <th class="vorstvrijcol" style="font-size: 12px;">VORSTVRIJ</th>
        <th class="defectcol" style="font-size: 12px;" >DEFECT</th>
        <th class="hlcol" style="font-size: 12px;">HL</th>
        <th class="vikcol" style="font-size: 12px;">VIK</th>
        <th class="riecol" style="font-size: 12px;">RIE</th>
        <th class="cecol" style="font-size: 12px;">CE</th>
        <th class="idvcol" style="font-size: 12px;" >IDV</th>
      </tr>
      <tr style="max-height: 70px;margin: 0px;padding:0px;">
        <th class="idcol headercell" >
          <v-text-field
          class="textfieldcell"
            v-model="IDfilter"
            label=""
            prepend-icon="filter_list"
            @input="updateFilters"
          ></v-text-field>
        </th>
        <th class="omschrcol headercell">
          <v-text-field class="textfieldcell"
            v-model="materieelfilter"
            label=""
            prepend-icon="search"
            @input="updateFilters"
          ></v-text-field>
        </th>
        <th class="loccol headercell" style="padding-top: 0px;">
          <v-autocomplete
                       v-bind:items="locdata"
                       v-model="LOCfilterModel"
                       item-text="text"
                       item-value="werfnr"
                       return-object
                       single-line
                       no-data-text="Geen Gegevens"
                       @input="updateFilters"
                       style="padding-top: 0px;margin-top: 0px;"
                     ></v-autocomplete>
        </th>
        <th class="urofkmcol headercell">

        <button v-bind:class="{omringd : UrofkmFilter==-1}" style="background-color: white;width: 30px;height: 30px;" v-on:click="seturofkmfilter(-1)"></button>
        <button v-bind:class="{omringd : UrofkmFilter==1}" style="background-color: orange;width: 30px;height: 30px;" v-on:click="seturofkmfilter(1)"></button>
        <button v-bind:class="{omringd : UrofkmFilter==0}" style="background-color: red;width: 30px;height: 30px;" v-on:click="seturofkmfilter(0)"></button>

        </th>
        <th class="periodiekecol headercell">

          <button v-bind:class="{omringd : PeriodiekeFilter==-1}" style="background-color: white;width: 30px;height: 30px;" v-on:click="setPeriodiekeFilter(-1)"></button>
          <button v-bind:class="{omringd : PeriodiekeFilter==1}" style="background-color: orange;width: 30px;height: 30px;" v-on:click="setPeriodiekeFilter(1)"></button>
          <button v-bind:class="{omringd : PeriodiekeFilter==0}" style="background-color: red;width: 30px;height: 30px;" v-on:click="setPeriodiekeFilter(0)"></button>

        </th>
        <th class="vorstvrijcol headercell"><v-checkbox style="margin: 0px;margin-left: 20px;" hide-details v-model="vorstvrijfilter" @change="updateFilters"></v-checkbox></th>
        <th class="defectcol headercell"><v-checkbox style="margin: 0px;margin-left: 20px;" hide-details v-model="defectfilter" @change="updateFilters"></v-checkbox></th>
        <th class="hlcol headercell"></th>
        <th class="vikcol headercell"></th>
        <th class="riecol headercell"></th>
        <th class="cecol headercell"></th>
        <th class="idvcol headercell"></th>
      </tr>
    </thead>
    <tbody>
      <tr >
        <td colspan="12" style="height: 196px;">
        </td>
      </tr>

      <div v-for="entry in matdata" class="matgroep">

        <tr @click="clickedSoort(entry)" :class="{'emptysoort-row': entry.dat.length === 0}">
          <td colspan="12" :class="['soortrow', {'emptysoort': entry.dat.length === 0}]">
            <div>{{entry.soortID}} - {{entry.soort}}</div>
          </td>
        </tr>

      <tr v-for="e in entry.dat" @click="clicked(e)" v-bind:class="{selectedRow : e.selected}">
        <td class="idcol">
          <div>{{e.soortID}}.{{e.volgnr}}</div>
        </td>
        <td class="omschrcol" style="text-overflow: ellipsis;">
          <div>{{e.omschrtekst}}</div>
        </td>
        <td class="loccol" >
          <div>{{e.locatieHuidig}}</div>
        </td>
        <td v-bind:class="{urofkmcol : true, oranjeachtergrond : e.oranjeachtergrond, rodeachtergrond : e.rodeachtergrond}" >
          <div>{{e.urenofkmoh}}</div>
        </td>
        <td v-bind:class="{periodiekecol : true, oranjeachtergrond : e.oranjeachtergrondperiodiek, rodeachtergrond : e.rodeachtergrondperiodiek}" >
          <div>{{e.periodiekecontrole}}</div>
        </td>
        <td class="vorstvrijcol" style="padding-left: 32px;">
          <div v-if="e.vorstvrij">&#10003;</div>
        </td>
        <td class="defectcol" style="padding-left: 32px;">
          <div v-if="e.defect">&#10003;</div>
        </td>
        <td class="hlcol" style="padding-left: 0px;">
          <div v-if="e.HL">&#10003;</div>
        </td>
        <td class="vikcol" style="padding-left: 0px;">
          <div v-if="e.VIK">&#10003;</div>
        </td>
        <td class="riecol" style="padding-left: 0px;">
          <div v-if="e.RIE">&#10003;</div>
        </td>
        <td class="cecol" style="padding-left: 0px;">
          <div v-if="e.CE">&#10003;</div>
        </td>
        <td class="idvcol" style="padding-left: 0px;">
          <div v-if="e.IDV">&#10003;</div>
        </td>
      </tr>
      </div>

    </tbody>
  </table>
  </div>

<div v-show="!lijstofdetail">
  <materieeldetail @backMaterieel="backMaterieel" :werven="werven" :soortendata="soortendata"></materieeldetail>
</div>




<v-layout row justify-center>
  <v-dialog v-model="showNewMachineDialog" width ="400px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Machine Toevoegen</span>
      </v-card-title>
      <v-card-text>
        <v-select
                     v-bind:items="soortendata"
                     v-model="nieuweMachineSoort"
                     item-text="text"
                     item-value="soortID"
                     return-object
                     label="soort"
                     single-line
                     required
                     no-data-text="Geen Gegevens"
                   ></v-select>
        <v-text-field v-model="nieuweMachineVolgnr" label="volgnr" required></v-text-field>
        <v-text-field v-model="nieuweMachineMerk" label="merk" required></v-text-field>
        <v-text-field v-model="nieuweMachineOmschr" label="type" required></v-text-field>
        <v-text-field v-model="nieuweMachineJaar" label="bouw-/aankoopjaar" required></v-text-field>
        <v-text-field v-model="nieuweMachineSerienr" label="serienr" required></v-text-field>

        <div class="red--text">{{TError}}</div>
      </v-card-text>
      <v-card-actions>
        <v-btn class="blue--text darken-1" @click.native="showNewMachineDialog = false">Sluiten</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="blue--text darken-1" @click.native="nieuweMachineSaveClick">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout>

<v-layout row justify-center>
  <v-dialog v-model="showNewSoortDialog" width ="400px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline" v-if="nieuweSoortWijzigen">Soort Wijzigen</span>
        <span class="headline" v-if="!nieuweSoortWijzigen">Soort Toevoegen</span>
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="nieuweSoortID" label="NR" @input="nieuweSoortDataGewijzigd" hint="bijvoorbeeld: 01" :disabled="nieuweSoortWijzigen" required></v-text-field>
        <v-text-field v-model="nieuweSoortNaam" label="NAAM" @input="nieuweSoortDataGewijzigd" hint="bijvoorbeeld: Traktor" required></v-text-field>
        <v-text-field v-model="nieuweSoortMap" label="SUBMAP" hint="mapnaam op de cloud" required></v-text-field>
        <div class="red--text">{{TError}}</div>
      </v-card-text>
      <v-card-actions>
        <v-btn class="blue--text darken-1" @click.native="showNewSoortDialog = false">Sluiten</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="nieuweSoortWijzigen"
          class="red--text darken-1"
          :disabled="soortHeeftMachines"
          @click.native="soortVerwijderenClicked"
        >
          Verwijderen
        </v-btn>
        <v-spacer v-if="nieuweSoortWijzigen"></v-spacer>
        <v-btn class="blue--text darken-1" @click.native="nieuweSoortSaveClick">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout>

</div>
</template>

<script>
import datareq from './datareq.js'
import functions from './functions.js'
import materieeldetail from './materieeldetail.vue'
import jsPDF from 'jspdf'
import autotable from 'jspdf-autotable'
  export default {
    components: {
      datareq,
      functions,
      materieeldetail,
      jsPDF
    },
    created: function () {
      this.$bus.$on('laadMaterieel', this.laden)
      this.$bus.$on('laadMachineDetailGlobal', this.laadDetailGlobal)
    },
    data () {
      return {
        matdata: [],
        columns: [
          {key: 'ID', value: 'ID', classes: 'bold'}
        ],

        locdata: [],
        werven: [],

        selicon: 'check',
        selmode: 0,

        IDfilter: '',
        materieelfilter: '',
        LOCfilter: '',
        LOCfilterModel: [],
        defectfilter: false,
        vorstvrijfilter: false,
        Defectfilter: 0,
        Vorstvrijfilter: 0,
        UrofkmFilter: -1,
        PeriodiekeFilter: -1,
        perpagina: 9999,
        pagina: 0,
        lijstofdetail: true,
        showNewMachineDialog: false,
        nieuweMachineSoort: null,
        nieuweMachineVolgnr: '',
        nieuweMachineOmschr: '',
        nieuweMachineMerk: '',
        nieuweMachineJaar: '',
        nieuweMachineSerienr: '',

        materieel: [],
        soortendata: [],
        soorten: [],
        showNewSoortDialog: false,
        nieuweSoortWijzigen: false,
        nieuweSoortID: '',
        nieuweSoortNaam: '',
        nieuweSoortMap: '',
        storescrollpos: 0,

        TError: '',
        TErrorShow: false,
        soortHeeftMachines: false
      }
    },
    methods: {
      laden: function () {
        datareq.getData('GetWerven', {idfilter: '', werffilter: '', perpagina : 9999, pagina: 0}, this.jsonWervenReceived)
        datareq.getData('GetSoorten', {}, this.jsonSoortenReceived)
        this.updateFilters()
      },
      laadDetailGlobal: function (d) {
        this.$bus.$emit('laadMaterieelDetail', [{sid: d.sid, vid: d.vid}])
        this.storescrollpos = 0
        this.lijstofdetail = false
      },
      selectClick: function () {
        if(this.selmode === 0) {
          this.selmode = 1
          this.selicon = 'done_all'
        }
        else if(this.selmode === 1) {
          this.selmode = 0
          this.selicon = 'check'
          for (var m of this.matdata) {
            for (var d of m.dat) {
              d.selected = false
            }
          }
          // loop through all this.matdata and check each .dat set selected to false
        }
      },
      nieuweSoortDataGewijzigd: function () {
        this.nieuweSoortMap = this.nieuweSoortID + '_' + this.nieuweSoortNaam
      },
      seturofkmfilter: function (i) {
        this.UrofkmFilter = i
        this.updateFilters()
      },
      setPeriodiekeFilter: function (i) {
        this.PeriodiekeFilter = i
        this.updateFilters()
      },
      nieuweSoortSaveClick: function () {
        if(this.nieuweSoortID != '') {
          if(this.nieuweSoortNaam != '') {
            if(this.nieuweSoortMap != '') {
              if(this.nieuweSoortWijzigen) {
                datareq.getData('WijzigSoort', {ID: this.nieuweSoortID, naam: this.nieuweSoortNaam, submap: this.nieuweSoortMap}, this.jsonNieuweSoortSaved)
              } else {
                datareq.getData('NieuweSoort', {ID: this.nieuweSoortID, naam: this.nieuweSoortNaam, submap: this.nieuweSoortMap}, this.jsonNieuweSoortSaved)
              }


            } else {
              this.TError = 'Vul submap in.'
              this.TErrorShow = true
            }
          } else {
            this.TError = 'Vul naam in.'
            this.TErrorShow = true
          }
        } else {
          this.TError = 'Vul een nr in.'
          this.TErrorShow = true
        }
      },
      jsonNieuweSoortSaved: function (data) {
        var status = data.status
        var d = data.data
        if (status === 'OK') {
          if(d === 1) {
            this.showNewSoortDialog = false
            this.laden()
          } else if (d === 2) {
            this.TError = 'Dit nummer bestaat al.'
          }
        } else {
        }
      },
      soortVerwijderenClicked: function () {
        if (this.soortHeeftMachines) {
          return
        }
        datareq.getData('SoortVerwijderen', {ID: this.nieuweSoortID}, this.jsonSoortVerwijderd)
      },
      jsonSoortVerwijderd: function (data) {
        var status = data.status
        var d = data.data
        if (status === 'OK') {
          if (d === 1) {
            this.showNewSoortDialog = false
            this.laden()
          } else if (d === 2) {
            this.TError = 'Deze soort kan niet verwijderd worden.'
            this.TErrorShow = true
          }
        } else {
        }
      },
      nieuweMachineSaveClick: function () {
        if(this.nieuweMachineSoort != null) {
          if(this.nieuweMachineVolgnr != '') {
            if(this.nieuweMachineOmschr != '') {
              datareq.getData('NieuweMachine', {soortID: this.nieuweMachineSoort.soortID, volgID: this.nieuweMachineVolgnr, omschr : this.nieuweMachineOmschr, merk: this.nieuweMachineMerk, jaar: this.nieuweMachineJaar, serienr: this.nieuweMachineSerienr}, this.jsonNieuweMachineSaved)
            } else {
              this.TError = 'Vul omschrijving in.'
              this.TErrorShow = true
            }
          } else {
            this.TError = 'Vul volgnummer in.'
            this.TErrorShow = true
          }
        } else {
          this.TError = 'Kies een soort.'
          this.TErrorShow = true
        }

      },
      jsonNieuweMachineSaved: function (data) {
        var status = data.status
        var d = data.data
        if (status === 'OK') {
          if(d === 1) {
            this.showNewMachineDialog = false
            this.laden()
          } else if (d === 2) {
            this.TError = 'Dit volgnr voor deze soort bestaat al.'
            this.TErrorShow = true
          }
        } else {
        }
      },
      clicked: function (machine) {
        if(this.selmode === 0) {
          this.storescrollpos = window.pageYOffset
          this.$bus.$emit('laadMaterieelDetail', [{sid: machine.soortID, vid: machine.volgnr}])
          this.lijstofdetail = false
        } else {
          this.$set(machine, 'selected', !machine.selected)
          this.$forceUpdate()
        }
      },
      clickedSoort: function (soort) {
        this.showNewSoortDialog = true
        this.nieuweSoortWijzigen = true
        this.nieuweSoortID = soort.soortID
        this.TError = ''
        this.nieuweSoortNaam = soort.soort
        this.nieuweSoortMap = soort.submap
        this.soortHeeftMachines = !(soort.dat && soort.dat.length === 0)
      },
      backMaterieel: function () {
        this.lijstofdetail = true
        this.updateFilters()
      },
      jsonSoortenReceived: function (data) {
        var status = data.status
        this.soortendata = []
        this.soorten = []
        if (status === 'OK') {
          var d = data.data
          this.soorten = d
          for (var s of d) {
            var n = {text: s.soortID + ' - ' + s.soort, soortID: s.soortID}
            this.soortendata.push(n)
          }
          this.appendEmptySoorten()
        } else {
        }
      },
      jsonWervenReceived: function (data) {
        var status = data.status
        this.locdata = []
        this.werven = []
        if (status === 'OK') {
          var d = data.data
          this.werven = d
          var i = 1
          for (var w of d) {

            var n = {text: w.werfnr + ' - ' + w.werfnaam, werfnr: w.werfnr}
            if(i === 1) {
              n.text = "-"
            }
            this.locdata.push(n)
            i = i + 1
          }
          this.LOCfilterModel = this.locdata[0]
        } else {
        }
      },
      updateFilters: function () {
        if (this.LOCfilterModel.werfnr === '---') {
          this.LOCfilter.werfnr = ''
        } else {
          this.LOCfilter = this.LOCfilterModel.werfnr
        }
        this.Defectfilter =      this.defectfilter==true?'1':'0'
        this.Vorstvrijfilter =   this.vorstvrijfilter==true?'1':'0'

        datareq.getData('GetMachines', {IDFilter: this.IDfilter, materieelfilter: this.materieelfilter, LOCFilter: this.LOCfilter, DefectFilter: this.Defectfilter, VorstvrijFilter: this.Vorstvrijfilter, UrofkmFilter: this.UrofkmFilter, PeriodiekeFilter: this.PeriodiekeFilter, perpagina : this.perpagina, pagina: this.pagina}, this.jsonMaterieelReceived)
      },
      jsonMaterieelReceived: function (data) {
        var status = data.status
        if (status === 'OK') {
          this.validlogin = true
          this.materieel = data.data
          //console.log(this.materieel[0])

          this.matdata = []
          var previousid = '-1'
          var groep = []
          for (var m of this.materieel) {

            if(previousid !== m.soortID)
            {
              if(previousid !== '-1') {
                this.matdata.push(groep)
              }
              groep = []
              groep.soort = m.soort
              groep.soortID = m.soortID
              groep.submap = m.submap
              groep.dat = []

              previousid = m.soortID
            }

            var nieuw = []
            nieuw.soort = m.soort
            nieuw.volgnr = m.volgnr
            nieuw.soortID = m.soortID
            nieuw.omschr = m.omschr
            nieuw.locatieHuidig = m.locatieHuidig
            nieuw.urenofkmoh = m.def
            nieuw.periodiekecontrole = m.periodiekecontrole
            nieuw.vorst = m.vorst
            nieuw.def = m.def
            nieuw.HL = m.HL
            nieuw.VIK = m.VIK
            nieuw.RIE = m.RIE
            nieuw.CE = m.CE
            nieuw.IDV = m.IDV
            nieuw.selected = false

            var merktekst = '';
            if(m.merk != '' && m.merk != null) {
              merktekst = m.merk + ' - '
            }
            var jaartekst = '';
            if(m.bouwjaar != '' && m.bouwjaar != "0000") {
              jaartekst = ' - ' + m.bouwjaar
            }
            var serienrtekst = '';
            if(m.serienr != '' && m.serienr != null) {
              serienrtekst = ' - ' + m.serienr
            }
            nieuw.omschrtekst = merktekst + nieuw.omschr + jaartekst + serienrtekst


            nieuw.oranjeachtergrond = false
            nieuw.rodeachtergrond = false
            nieuw.oranjeachtergrondperiodiek = false
            nieuw.rodeachtergrondperiodiek = false

            if(m.datofuren == '0')
            {
              nieuw.urenofkmoh = Math.round(m.urofkm)

              var diff = parseFloat(m.omde) + parseFloat(m.urofkm2) - parseFloat(m.urofkm);

              if(parseFloat(m.urofkm) > 0 && parseFloat(m.omde) > 0)
              {
                  if(diff < 40 && diff > 0)
                  {
                    nieuw.oranjeachtergrond = true
                  } else if( diff <= 0) {
                    nieuw.rodeachtergrond = true
                  }
              }
              if(m.omde > 0)
              {
                var percentage = (parseFloat(m.urofkm) - parseFloat(m.urofkm2)) / parseFloat(m.omde);
              }
            }
            else
            {
              nieuw.urenofkmoh = functions.dat2str(m.datonderh)

              var vandaag = new Date()
              var oh = functions.str2dat(m.datonderh)
              var diff = functions.dateDiffInDays(oh,vandaag)
              if(diff < 14 && diff > 0)
              {
                nieuw.oranjeachtergrond = true
              } else if( diff <= 0) {
                nieuw.rodeachtergrond = true
              }

            }

            if(m.geldigtot === '0000-00-00')
        		{
        		    nieuw.periodiekecontrole = '-'
        		}
        		else
        		{
        		    nieuw.periodiekecontrole = functions.dat2str(m.geldigtot)

        		    var vandaag = new Date()
        		    var oh = functions.str2dat(m.geldigtot)
        		    var diff = functions.dateDiffInDays(oh,vandaag)
        		    if(diff < 14 && diff > 0)
        		    {
        		        nieuw.oranjeachtergrondperiodiek = true
        		    } else if( diff <= 0) {
        		        nieuw.rodeachtergrondperiodiek = true
        		    }
        		}

        		nieuw.vorstvrij = m.vorstvrij>0?true:false
        		nieuw.defect = m.defect>0?true:false
            nieuw.HL = m.HL>0?true:false
            nieuw.VIK = m.VIK>0?true:false
            nieuw.RIE = m.RIE>0?true:false
            nieuw.CE = m.CE>0?true:false
            nieuw.IDV = m.IDV>0?true:false
            nieuw.submap = m.submap

            groep.dat.push(nieuw)
          }

          if(groep !== []) {
            this.matdata.push(groep)
          }
          this.appendEmptySoorten()
          //window.alert('scrollto' + this.storescrollpos)
        //  window.ScrollTo(0,this.storescrollpos)

        } else {
          this.errormsg = 'Gebruikersnaam of wachtwoord ongeldig.'
          this.showError = true
        }
      },
      appendEmptySoorten: function () {
        if (!this.soorten || this.soorten.length === 0) {
          return
        }
        var bestaandeSoorten = {}
        for (var g of this.matdata) {
          bestaandeSoorten[g.soortID] = true
        }
        var extra = []
        for (var s of this.soorten) {
          if (!bestaandeSoorten[s.soortID]) {
            var groep = []
            groep.soort = s.soort
            groep.soortID = s.soortID
            groep.submap = s.submap
            groep.dat = []
            extra.push(groep)
          }
        }
        if (extra.length > 0) {
          this.matdata = this.matdata.concat(extra)
        }
      },
      nieuweMachineClicked: function () {
        this.TErrorShow = false
        this.showNewMachineDialog = true
        this.nieuweMachineSoort = null
        this.nieuweMachineVolgnr = ''
        this.nieuweMachineOmschr = ''
        this.nieuweMachineMerk = ''
        this.nieuweMachineJaar = ''
        this.nieuweMachineSerienr = ''
      },
      nieuweSoortClicked: function () {
        this.showNewSoortDialog = true
        this.nieuweSoortWijzigen = false
        this.nieuweSoortID = ''
        this.TError = ''
        this.nieuweSoortNaam = ''
        this.nieuweSoortMap = ''
        this.soortHeeftMachines = false
      },
      steekkaartenClicked: function () {
        var lijst = []
        // loop through all this.matdata and check each .dat set selected to false
        for (var m of this.matdata) {
          for (var d of m.dat) {
            if (d.selected) {
              var o = {s: d.soortID, v : d.volgnr}
              lijst.push(o)
            }
          }
        }
        if (lijst.length > 0) {
          datareq.getData('GetMachinesWithIds', {lijst: lijst}, this.jsonGetMachinesWithIdsReceived)
        }
      },
      jsonGetMachinesWithIdsReceived: function (data) {
        var status = data.status
        if (status === 'OK') {
          //console.log(data.data)
          var lijst = []
          for (var m of data.data) {
            var o = {}
            // this.calcDatLocStr()
            o.omschrijving = m.omschr;
            o.soortID = m.soortID
            o.volgnr = m.volgnr
            o.vorstvrij = m.vorstvrij
            o.soortdesc = m.soort
            o.defect = m.defect
            o.selectedWerfText = m.locatieHuidig
            o.datlocstr = functions.calcDatLocStr(m.datLOC)
            o.selectedWerf2Text = m.locatieVorig
            o.datloc2str = functions.calcDatLocStr(m.datLOC2)
            o.selectedWerf3Text = m.locatieVorigVorig
            o.datloc3str = functions.calcDatLocStr(m.datLOC3)
            o.huidigeurenstand = this.urofkm
            o.datumurenopgenomenop = this.opgenomenop
            o.vorigeurenstand = this.urofkm2
            o.omde = m.omde
            o.onderhoudtekst = m.onderhoudtekst
            o.keuringtekst = m.keuringopmtekst
            o.ureningave = this.ureningave
            lijst.push(o)
          }
          //console.log(lijst)
          functions.afdrukkenSteekkaart(lijst)
        }
      },
      afdrukkenClicked: function () {
        var obj = {}
        obj.IDFilter = this.IDfilter
        obj.materieelfilter = this.materieelfilter
        obj.LOCFilter = this.LOCfilter
        obj.DefectFilter =      this.defectfilter==true?'1':'0'
        obj.VorstvrijFilter =   this.vorstvrijfilter==true?'1':'0'
        obj.UrofkmFilter = this.UrofkmFilter
        obj.PeriodiekeFilter = this.PeriodiekeFilter
        obj.perpagina = this.perpagina
        obj.pagina = this.pagina
        datareq.getData('GetMachines', obj, this.jsoncallbackAfdrukken)
      },
      jsoncallbackAfdrukken: function (data) {
        var status = data.status
        if (status === 'OK') {
          var res = data.data
          var columns = [
          {header: "Defect", dataKey: "defect"},
          {header: "ID", dataKey: "id"},
          {header: "Omschrijving", dataKey: "omsch"},
          {header: "Huidige\nLocatie", dataKey: "loc"},
          {header: "UREN /\nKM /\nONDERH", dataKey: "urofkm"},
          {header: 'Periodieke\ncontrole\ngeldig tot', dataKey: "period"},
          {header: "Vorstvrij", dataKey: "vorstvrij"}
        ];

          var rows = [];
          var vorigesoort = "-1";
          var soort = "";
          for (var i = 0; i < res.length; i++) {
              //console.log(arr[i]);
          var urofkm = [];
          var periodiekecontrolegeldigtot = [];
          var kleur = 0; // 0=neutraal, 1=oranje, 2 = rood
          var periodiekekleur = 0;
          var soort = res[i].soort;
          if(res[i].datonderh == '0000-00-00')
          {
              urofkm = Math.round(res[i].urofkm);

              var diff = parseFloat(res[i].omde) + parseFloat(res[i].onderhurofkm) - parseFloat(res[i].urofkm);
              if(parseFloat(res[i].urofkm) > 0 && parseFloat(res[i].omde) > 0)
              {
                  if(diff < 40 && diff > 0)
                  {
                      kleur = 1;
                  } else if( diff <= 0) {
                      kleur = 2;
                  }
              }
          }
          else
          {
              urofkm = functions.dat2str(res[i].datonderh);

              var vandaag = new Date();
              var oh = functions.str2dat(res[i].datonderh);
              var diff = functions.dateDiffInDays(oh,vandaag);
              if(diff < 14 && diff > 0)
              {
                  kleur = 1;
              } else if( diff <= 0) {
                  kleur = 2;
              }
          }

          if(res[i].geldigtot == '0000-00-00')
          {
              periodiekecontrolegeldigtot = "-";
          }
          else
          {
              periodiekecontrolegeldigtot = functions.dat2str(res[i].geldigtot);

              var vandaag = new Date();
              var oh = functions.str2dat(res[i].geldigtot);
              var diff = functions.dateDiffInDays(oh,vandaag);
              if(diff < 14 && diff > 0)
              {
                  periodiekekleur = 1;
              } else if( diff <= 0) {
                  periodiekekleur = 2;
              }

          }

          var nieuwesoort = "";

              if(soort != vorigesoort)
              {
                  nieuwesoort = res[i].soortID + " - " + soort;
                  rows.push({ id: res[i].soortID, omsch: soort, loc: '', urofkm: '', period: '',vorstvrij: '',defect: '', ce: '', idv: '', hl: '', vik: '', rie: '', nieuwesoort: nieuwesoort });
              }

              rows.push({ id: res[i].soortID + "." + res[i].volgnr, omsch: res[i].omschr, loc: res[i].locatieHuidig, urofkm: urofkm, period: periodiekecontrolegeldigtot,vorstvrij: res[i].vorstvrij,defect: res[i].defect, ce: res[i].CE, idv: res[i].IDV, hl: res[i].HL, vik: res[i].VIK, rie: res[i].RIE, nieuwesoort: '' });
              vorigesoort = soort;
          }

          // Only pt supported (not mm or in)
          var doc = new jsPDF('p', 'pt', 'a4');
          doc.text('Materieellijst',95, 60 );
          doc.addImage(functions.getVLBLogo(), 'JPEG', 40, 40, 48, 30);

          var currentdate = new Date();
          var datetime = "Datum afdruk: " + currentdate.getDate() + "/"
                  + (currentdate.getMonth()+1)  + "/"
                  + currentdate.getFullYear() + " - "
                  + currentdate.getHours() + ":"
                  + currentdate.getMinutes();

          doc.setFontSize(8);
          doc.text(datetime,550, 60 ,'right');

          var header = function (data) {
          }

          var totalPagesExp = "{total_pages_count_string}";
          var footer = function (data) {
          var str = "Pagina " + data.pageCount;
          if (typeof doc.putTotalPages === 'function') {
              str = str + " van " + totalPagesExp;
          }
          doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 30);
          }


          var options = {
            addPageContent: header,
              vorigesoort : "",
              drawRow: function (row, data) {

                  doc.setFontStyle('bold');
                  doc.setFontSize(10);

                  if (row.raw.nieuwesoort != "") {
                      doc.setTextColor(0, 0, 0);
                      doc.rect(data.settings.margin.left, row.y, data.table.width, 20, 'S');
                      doc.autoTableText(row.raw.nieuwesoort, data.settings.margin.left + 5, row.y + row.height / 2, {
                          halign: 'left',
                          valign: 'middle'
                      });
                      data.cursor.y += 20;
                  }

              },
              createdCell: function (cell, data) {
                  if (data.column.dataKey === 'urofkm' || data.column.dataKey === 'period') {
                      cell.styles.halign = 'right';
                  } else if (data.column.dataKey === 'vorstvrij') {
                      cell.styles.halign = 'center';
                      if (cell.raw > 0) {
                          cell.styles.textColor = [0, 0, 0];
                          cell.text = "VORSTVRIJ";
                      } else {
                          cell.text = "";
                      }
                  } else if (data.column.dataKey === 'defect') {
                      cell.styles.halign = 'center';
                      if (cell.raw > 0) {
                          cell.styles.textColor = [0, 0, 0];
                          cell.text = "DEFECT";
                      } else {
                          cell.text = "";
                      }
                  }
              },
              addPageContent: footer
              //,
              //beforePageContent: header,
              //afterPageContent: footer
          }

// options
          doc.autoTable(
            {
              columns: columns,
              body: rows,
              startY: 75,
              styles: {
                 // font: 'courier',
                  fillStyle: 'DF',
                  lineColor: [128, 128, 128],
                  fontSize: 7,
                  lineWidth: 0,
                  overflow: 'linebreak'
              },
              headStyles: {
                  fillColor: [200, 200, 200],
                  textColor: [255,255,255],
                  fontSize: 7,
                  cellPadding : 2
              },
              bodyStyles: {
                  fillColor: [255, 255, 255],
                  textColor: 0
              },
              alternateRowStyles: {
                  fillColor: [255, 255, 255]
              },
              columnStyles: {
                  id: {
                      cellWidth: 50
                  },
                  omsch: {
                      cellWidth: 175
                  },
                  loc: {
                      cellWidth: 90
                  },
                  urofkm: {
                      cellWidth: 55
                  },
                  period: {
                      cellWidth: 55
                  },
                  vorstvrij: {
                      cellWidth: 50
                  },
                  defect: {
                      cellWidth: 40
                  }
              },
              vorigesoort : "",
              willDrawCell: function (data) {
                  //console.log(data)

                  if(data.row.raw.defect == 'Defect') { // we are drawing a header

                  } else {
                    doc.setFont('helvetica','normal')
                    //doc.setFontStyle('bold');
                    doc.setFontSize(7);

                    if (data.row.raw.nieuwesoort != "") {
                        doc.setTextColor(0, 0, 0);
                        doc.setFont('helvetica','bold')
                        doc.setFontSize(10);
                        if(data.column.dataKey === 'urofkm') {
                          //data.cursor.y += 20;
                          var tablew = 515
                          /*
                          for (var item of data.table.columns) {
                            tablew = tablew + item.wrappedWidth;
                          }
                          */
                          doc.rect(data.settings.margin.left, data.cell.y + 2, tablew, 16, 'S');
                        }

                        /*
                        doc.autoTableText(data.row.raw.nieuwesoort, data.settings.margin.left + 5, data.row.y + data.row.height / 2, {
                            halign: 'left',
                            valign: 'middle'
                        });
                        */
                      //  data.cursor.y += 20;
                    }
                  }



              },
              didParseCell: function (data) {
                //console.log(data)
                if(data.row.raw.defect == 'Defect') { // we are drawing a header

                } else {
                  if (data.column.dataKey === 'urofkm' || data.column.dataKey === 'period') {
                      data.cell.styles.halign = 'right';
                  } else if (data.column.dataKey === 'vorstvrij') {
                      data.cell.styles.halign = 'center';
                      if (data.cell.raw > 0) {
                          data.cell.styles.textColor = [0, 0, 0];
                          data.cell.text = "VORSTVRIJ";
                      } else {
                          data.cell.text = "";
                      }
                  } else if (data.column.dataKey === 'defect') {
                      data.cell.styles.halign = 'center';
                      if (data.cell.raw > 0) {
                          data.cell.styles.textColor = [0, 0, 0];
                          data.cell.text = "DEFECT";
                      } else {
                          data.cell.text = "";
                      }
                  }
                }

              }
            });

          if (typeof doc.putTotalPages === 'function') {
              doc.putTotalPages(totalPagesExp);
          }
          doc.save('materieellijst.pdf');

        } else {
          this.errormsg = 'Gebruikersnaam of wachtwoord ongeldig.'
          this.showError = true
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'


</style>


<style scoped>
body {
  font-family: Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  color: #444;
}

table {
  width: 1430px;
  border: 2px solid gray;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0px 0px 10px darkgrey;
  border-collapse: collapse;
}

th {
  background-color: #ebebeb;
  color: black;
  -webkit-user-select: none;
  -moz-user-select: none;
  -user-select: none;
  cursor: auto;
}


.topclass {
  padding: 0px;
  padding-top: 0px;
}

.alignright {
  text-align: right;
}

.bold {
  font-weight: bold;
}

tr {
  cursor: pointer;
  text-align: left;
  white-space: pre-wrap;

}

tr:nth-child(odd) {
  background-color: #f2f2f2;
  color: #000000;
}

tr:hover {
  background-color: #cde9ef;
  cursor: pointer;
}

.soortrow {
  background-color: #e49370;
  cursor: pointer;
}

.soortrow:hover {
  background-color: #cde9ef;
  cursor: pointer;
}

.emptysoort {
  background-color: #d3d3d3 !important;
}

.emptysoort-row td {
  width: 1579px;
}

.emptysoort div {
  display: block;
  width: 1579px;
}

.emptysoort-row:hover .emptysoort {
  background-color: #bfbfbf !important;
}

.selectedRow {
  background-color: #4caf50 !important;
}


td {
  min-width: 10px;
  padding: 5px 5px;
  margin: 0px;
  border: 1px solid black;
}

.idcol {
  width: 90px;min-width: 90px;max-width: 90px;
}

.omschrcol {
  width: 400px;min-width: 400px;max-width: 400px;
}

.loccol {
  width: 300px;min-width: 300px;max-width: 300px;
}

.periodiekecol {
  width: 120px;min-width: 120px;max-width: 120px;
}

.urofkmcol {
  width: 120px;min-width: 120px;max-width: 120px;
}
.vorstvrijcol {
  width: 80px;min-width: 80px;max-width: 80px;
}
.defectcol {
  width: 80px;min-width: 80px;max-width: 80px;
}
.cecol {
  width: 80px;min-width: 80px;max-width: 80px;
  text-align: center;
}
.hlcol {
  width: 80px;min-width: 80px;max-width: 80px;
  text-align: center;
}
.vikcol {
  width: 80px;min-width: 80px;max-width: 80px;
  text-align: center;
}
.riecol {
  width: 80px;min-width: 80px;max-width: 80px;
  text-align: center;
}
.idvcol {
  width: 80px;min-width: 80px;max-width: 80px;
  text-align: center;
}


.headercell {
  height: 10px; margin: 0px; padding: 0px;
}

.textfieldcell {
   margin: 0px; padding: 0px;
}

.oranjeachtergrond {
  background-color: orange;
}

.rodeachtergrond {
  background-color: red;
}

.omringd {
  border: 2px solid black;
}


</style>



// WEBPACK FOOTER //
// materieel.vue?6a0e25ee